import { addTicketRating } from "@services/api";
import { store } from "@store";
import { actions as snackbarActions } from "@reducers/snackbarReducer";
import analytics from "@services/analytics";
import { SUPPORT_FLOW } from "@constants/analyticsEventsCT";

const payload = (message) => ({
  shouldShow: true,
  message,
  position: "bottom",
  bottom: 0,
  autoHidingTime: 3000,
  autoHide: true,
  actionText: "Okay",
  actionHandler: (e) => {
    store.dispatch(snackbarActions.hideSnackbar());
  },
});

const giveRating =
  (rating, ticket_id, issueLevel1, reasons = []) =>
  async (func1, func2) => {
    try {
      const { data: ratedTicket } = await addTicketRating({
        rating,
        ticket_id,
        reasons,
      });
      analytics.trackEvent(SUPPORT_FLOW.SUPPORT_TICKET_RATING, {
        type: issueLevel1.toString().toLowerCase(),
      });
      const { rating: newRating } = ratedTicket;
      if (func1 && typeof func1 === "function") func1();
      if (func2 && typeof func2 === "function") func2();
      if (newRating >= 4) {
        store.dispatch(
          snackbarActions.showSnackbar(
            payload("आपकी दी हुई रेटिंग सफलतापूर्वक सब्मिट कर ली गयी है  |"),
          ),
        );
        setTimeout(() => {
          store.dispatch(snackbarActions.hideSnackbar());
        }, 3000);
      }
    } catch (err) {
      console.log("rating error", err);
    }
  };

export default giveRating;
